import type { SxProps, Theme } from '@mui/material';

export const headerActionsGap = 1.5;

export const headerActionDividerSx: SxProps<Theme> = {
  width: '1px',
  height: 20,
  bgcolor: 'elevation.outlined',
  flexShrink: 0,
};

/** Brand lavender → purple. Used by the header Points pill (border + clipped text). */
const HEADER_POINTS_GRADIENT =
  'linear-gradient(90deg, var(--mui-palette-brand-indigo) 0%, var(--mui-palette-brand-purple) 100%)';

/** Outlined pill with gradient border. */
export const headerPointsTriggerSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.75,
  cursor: 'pointer',
  m: 0,
  px: 1.25,
  py: 0,
  minHeight: 32,
  font: 'inherit',
  fontSize: '0.8125rem',
  fontWeight: 500,
  lineHeight: 1,
  whiteSpace: 'nowrap',
  borderRadius: 1,
  border: '1px solid transparent',
  background: `linear-gradient(var(--mui-palette-background-paper-elevation-0), var(--mui-palette-background-paper-elevation-0)) padding-box, ${HEADER_POINTS_GRADIENT} border-box`,
  transition: 'filter 150ms ease, background-color 150ms ease',
  '&:hover': {
    filter: 'brightness(1.12)',
    background: `linear-gradient(var(--mui-palette-background-paper-elevation-1), var(--mui-palette-background-paper-elevation-1)) padding-box, ${HEADER_POINTS_GRADIENT} border-box`,
  },
};

const headerPointsGradientClipSx: SxProps<Theme> = {
  backgroundImage: HEADER_POINTS_GRADIENT,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
  WebkitTextFillColor: 'transparent',
};

export const headerPointsGradientFillSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.75,
  lineHeight: 1,
  whiteSpace: 'nowrap',
};

export const headerPointsIconSx: SxProps<Theme> = {
  height: 16,
  width: 16,
  flexShrink: 0,
  color: 'brand.indigo',
};

export const headerPointsValueSx: SxProps<Theme> = {
  ...headerPointsGradientClipSx,
};

export const headerPointsUnitSx: SxProps<Theme> = {
  fontWeight: 500,
  opacity: 0.85,
  ...headerPointsGradientClipSx,
};

export const getHeaderWalletTriggerSx = (isOpen: boolean): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.75,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  p: '8px 2px',
  m: 0,
  font: 'inherit',
  fontSize: '0.8125rem',
  fontWeight: 500,
  lineHeight: 1,
  color: isOpen ? 'text.primary' : 'text.secondary',
  transition: 'color 150ms ease',
  maxWidth: 200,
  '&:hover': { color: 'text.primary' },
});

export const headerWalletDotSx: SxProps<Theme> = {
  width: 7,
  height: 7,
  borderRadius: '50%',
  bgcolor: 'success.main',
  flexShrink: 0,
};

export const headerWalletCaretSx: SxProps<Theme> = {
  fontSize: 14,
  color: 'text.disabled',
  flexShrink: 0,
};

export const headerWalletAddressSx: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const headerDelegatedChipSx: SxProps<Theme> = {
  height: 18,
  fontSize: '0.625rem',
  flexShrink: 0,
};
